import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.owner}orders/salesReceipt/recognize`;

interface SaleReceiptRecognize {
  barcode: string;
  storeName: string;
  purchaseDate: string;
  totalPrice: number;
  totalPriceCurrency: string;
  receiptLines: [
    {
      description: string;
      productCode: string;
      price: number;
      quantity: number;
      totalPrice: number;
      totalPriceCurrency: string;
    },
  ];
}

const recognizeSalesReceiptCommand = async ({
  imageBase64,
}: {
  imageBase64: string;
}): Promise<BackResponse<SaleReceiptRecognize> | BackResponseFailure> => {
  try {
    const response = await apiCall<BackResponse<SaleReceiptRecognize>>(
      ENDPOINT,
      {
        method: SUPPORTED_METHODS.POST,
        json: {
          imageBase64,
        },
      },
    );

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default recognizeSalesReceiptCommand;
